import { DRAWER } from 'lib/env';
import { useContext } from 'react';
import { isMobileOnly } from 'react-device-detect';
import { Modal, Button } from 'rsuite';
import { ApplicationContext } from 'shared';

const Message = () => {
  const {
    errorIsVisible,
    messageBody,
    hideError,
    messageTitle,
    buttons,
    confirmationCallback,
    showDrawer,
    size
  } = useContext(ApplicationContext);

  return (
    <Modal backdrop="static" open={errorIsVisible} onClose={hideError} size={size} full={isMobileOnly}>
      <Modal.Header><Modal.Title>{messageTitle}</Modal.Title></Modal.Header>
      <Modal.Body>
        {messageBody}
      </Modal.Body>
      <Modal.Footer>
        {buttons.includes('ok') &&
          <Button size="sm" onClick={() => {
            hideError();
            if (typeof (confirmationCallback) !== 'undefined') {
              confirmationCallback();
            }
          }} appearance="primary">OK</Button>
        }

        {buttons.includes('close_feedback') &&
          <Button size="sm" onClick={() => {
            hideError();
            setTimeout(() => showDrawer(DRAWER.FEEDBACK));
          }} appearance="primary">Report Issue</Button>
        }

        {buttons.includes('close') &&
          <Button size="sm" onClick={hideError} appearance={buttons.length === 1 ? 'primary' : 'subtle'}>Close</Button>
        }

        {buttons.includes('cancel') &&
          <Button size="sm" onClick={hideError} appearance={buttons.length === 1 ? 'primary' : 'subtle'}>Cancel</Button>
        }
      </Modal.Footer>
    </Modal>
  );
}

export {
  Message
}
